'use strict';
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};



// WEBPACK FOOTER //
// ./~/core-js/internals/fails.js